export default __webpack_public_path__ + "static/media/production.4d6e804f.svg";